<template>
    <div class="">
        <el-input :disabled="!iscode" v-model="code" @blur="searchCode" class="m-0" :suffix-icon="'el-icon-' + icon"></el-input>
        <span :class="{'text-success': data.success, 'text-danger': !data.success }" style="font-size: 0.8rem;" v-text="data.message"></span>

    </div>
</template>
<script>
export default {
    name: 'PromotionalCode',
    props: {
        iscode: {
            type: Boolean,
            required: true,
            default: false
        },
        sport: {
            type: String,
            required: true,
            default: null
        }
    },
    data() {
        return {
            code: '',
            icon: 'search',
            data: {}
        }
    },
    methods: {
        formDatas(obj) {
            let formData = new FormData();
            for (var key in obj) {
                formData.append(key, obj[key]);
            }
            return formData;
        },
        searchCode() {
            this.icon = 'loading'
            let form = this.formDatas({
                code: this.code,
                sport: this.sport
            })
            axios.post(`${process.env.API1}/promotionalcode` , form).then(response => {
                this.data = response.data
                this.$emit("onPromotional", response.data)
                this.icon = 'search'
            })
            /*setTimeout(function () {
                console.log('Has dejado de escribir en el input')
            },1000)*/
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/common/PromotionalCode.vue